import { render } from "./TextUsIcon.vue?vue&type=template&id=96bb2bb8"
import script from "./TextUsIcon.vue?vue&type=script&lang=js"
export * from "./TextUsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/ChatIcons/TextUsIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "96bb2bb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('96bb2bb8', __exports__)) {
    api.reload('96bb2bb8', __exports__)
  }
  
  module.hot.accept("./TextUsIcon.vue?vue&type=template&id=96bb2bb8", () => {
    api.rerender('96bb2bb8', render)
  })

}


export default __exports__